import { EventEmitter } from 'events'
import { IS_DEV } from './environment'
import { genPayloadId } from './helpers'
import {
  IMessage,
  MessageNamespace,
  XDEFIBitcoinPayload,
  XDEFIBitcoinPayloadMethods,
} from './types'

export class XDEFIBitcoinProvider extends EventEmitter {
  private msgStream: any | undefined

  private callBacksMap: Map<number, any> | undefined

  private _chainId: string

  private _network: string

  constructor(msgStream?: any, callBacksMap?: Map<number, any>) {
    super()
    this.msgStream = msgStream
    this.callBacksMap = callBacksMap
    this._chainId = 'mainnet'
    this._network = 'mainnet'
  }

  get chainId() {
    return this._chainId
  }

  get network() {
    return this._network
  }

  // This will be called when accounts have changed and need to be re-pulled
  // by the dApp
  emitAccountsChanged() {
    this.emit('accountsChanged', {})
  }

  changeNetwork(_chainId: string, _network: string) {
    if (_chainId !== _network) {
      throw Error(
        `changeNetwork failed, incorrect _chainId-_network ${_chainId} ${_network}`
      )
    }
    if (!['mainnet', 'testnet'].includes(_chainId)) {
      throw Error(
        `changeNetwork failed, incorrect _chainId-_network ${_chainId} ${_network}`
      )
    }
    this._chainId = _chainId
    this._network = _network
    this.emit('chainChanged', {
      _chainId,
      _network,
    })
  }

  request(payload: XDEFIBitcoinPayload, callbackFunction: any) {
    if (IS_DEV) {
      console.log('<==== request bitcoin provider', payload)
    }

    const pId = genPayloadId()
    let msg

    switch (payload.method) {
      case XDEFIBitcoinPayloadMethods.REQUEST_ACCOUNTS:
      case XDEFIBitcoinPayloadMethods.SIGN_TRANSACTION:
      case XDEFIBitcoinPayloadMethods.GET_UNSPENT_UTXOS:
      case XDEFIBitcoinPayloadMethods.TRANSFER:
        msg = {
          name: 'xdefiprovider',
          data: {
            xdefiId: pId,
            origin: null,
            namespace: MessageNamespace.BITCOIN,
            raw: {
              id: pId,
              method: payload.method,
              params: payload.params,
            },
            time: Date.now(),
          } as IMessage,
        }
        if (callbackFunction && this.callBacksMap) {
          this.callBacksMap.set(msg.data.raw.id, callbackFunction)
        }
        if (this.msgStream) {
          this.msgStream.write(msg)
        }
        break
      default:
        throw Error(
          `XDEFI Bitcoin Provider: this method ${
            payload.method
          } is not supported`
        )
    }
    // return;
  }
}

export default XDEFIBitcoinProvider

const _initBitcoinProvider = (
  msgStream: any,
  callBacksMap: Map<number, any>
) => {
  return new XDEFIBitcoinProvider(msgStream, callBacksMap)
}

export const initBitcoinProvider = _initBitcoinProvider
